import EditorMain from "../../../components/EditorMain";
import tradoAuditEditorConfig from "../utils/tradoAuditEditorConfig";

// Everything that is specific to the trado audit editor, the rest is the shared EditorMain.
const tradoEditorVariant = {
  config: tradoAuditEditorConfig,
};

const AuditKendaraanTradoEditorMain = () => {
  return <EditorMain variant={tradoEditorVariant} />;
};

export default AuditKendaraanTradoEditorMain;
